import { httpClient } from './httpClient';

const base = '/api/usuarios';

export const listarUsuarios = () => httpClient.get(base);
export const obtenerUsuario = (id) => httpClient.get(`${base}/${id}`);
export const crearUsuario = (payload) => httpClient.post(base, payload);
export const actualizarUsuario = (id, payload) => httpClient.put(`${base}/${id}`, payload);
export const cambiarPassword = (id, payload) => httpClient.put(`${base}/${id}/password`, payload);
export const eliminarUsuario = (id) => httpClient.del(`${base}/${id}`);
export const desbloquearUsuario = (id) => httpClient.put(`${base}/${id}/desbloquear`);
export const obtenerMenuUsuario = () => httpClient.get(`${base}/menu`);
export const obtenerPermisosUsuario = (id) => httpClient.get(`${base}/${id}/permisos`);
export const actualizarPermisosUsuario = (id, permiso_ids) => httpClient.put(`${base}/${id}/permisos`, { permiso_ids });

const usuariosService = {
  listar: listarUsuarios,
  obtener: obtenerUsuario,
  crear: crearUsuario,
  actualizar: actualizarUsuario,
  cambiarPassword,
  eliminar: eliminarUsuario,
  desbloquear: desbloquearUsuario,
  menu: obtenerMenuUsuario
};

export default usuariosService;
